/* 7 O'CLOCK – Neue Navigation (snippets/7oc-nav.liquid), 07.10.2026
   Desktop: Mega-Menü per Hover (mit kleiner Verzögerung) und Tastatur, Escape schließt.
   Mobil: Drawer von links, Ebene 1 ↔ 2 ↔ 3, Overlay/Escape schließen, Body-Scroll gesperrt. Vanilla JS. */
(function () {
  'use strict';
  var root = document.querySelector('.nav_component.has-oc-nav');
  if (!root) return;

  /* ---------- Desktop Mega-Menü ---------- */
  var items = Array.prototype.slice.call(root.querySelectorAll('[data-oc-nav-item]'));
  var openTimer = null, closeTimer = null;
  function closeAll() {
    items.forEach(function (it) { it.classList.remove('is-open'); var t = it.querySelector('[data-oc-nav-top]'); if (t) t.setAttribute('aria-expanded', 'false'); });
  }
  function open(it) {
    closeAll();
    it.classList.add('is-open');
    var t = it.querySelector('[data-oc-nav-top]'); if (t) t.setAttribute('aria-expanded', 'true');
  }
  items.forEach(function (it) {
    it.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(function () { open(it); }, 90);
    });
    it.addEventListener('mouseleave', function () {
      clearTimeout(openTimer);
      closeTimer = setTimeout(closeAll, 140);
    });
    var top = it.querySelector('[data-oc-nav-top]');
    if (top) {
      top.addEventListener('focus', function () { open(it); });
      top.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); open(it); var first = it.querySelector('.oc-nav_sub'); if (first) first.focus(); }
      });
    }
    it.addEventListener('focusout', function (e) { if (!it.contains(e.relatedTarget)) it.classList.remove('is-open'); });
  });
  /* „Produkte“-Panel (Westwing-Stil, Alina 07.10.2026): Kategorie überfahren → Unterpunkte + Bild rechts */
  var prod = root.querySelector('.oc-nav_item.is-products');
  if (prod) {
    var pcats = Array.prototype.slice.call(prod.querySelectorAll('[data-oc-prod-cat]'));
    var psubs = Array.prototype.slice.call(prod.querySelectorAll('[data-oc-prod-sub]'));
    var setCat = function (id) {
      pcats.forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-oc-prod-cat') === id); });
      psubs.forEach(function (s) { s.hidden = s.getAttribute('data-oc-prod-sub') !== id; });
    };
    pcats.forEach(function (c) {
      var id = c.getAttribute('data-oc-prod-cat');
      c.addEventListener('mouseenter', function () { setCat(id); });
      c.addEventListener('focus', function () { setCat(id); });
    });
    if (pcats.length) setCat(pcats[0].getAttribute('data-oc-prod-cat'));
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); closeDrawer(); } });

  /* ---------- Mobil Drawer ---------- */
  var drawer = root.querySelector('[data-oc-nav-drawer]');
  var overlay = root.querySelector('[data-oc-nav-overlay]');
  var burger = root.querySelector('[data-oc-nav-open]');
  if (!drawer || !overlay || !burger) return;

  function showLevel(id) {
    var levels = drawer.querySelectorAll('[data-oc-nav-level]');
    Array.prototype.forEach.call(levels, function (lv) {
      var on = lv.getAttribute('data-oc-nav-level') === String(id);
      lv.hidden = !on;
      lv.classList.toggle('is-active', on);
      if (on) lv.scrollTop = 0;
    });
  }
  function openDrawer() {
    overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('is-visible'); drawer.classList.add('is-open'); });
    drawer.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('oc-nav-locked');
    showLevel('root');
  }
  function closeDrawer() {
    if (!drawer.classList.contains('is-open')) return;
    overlay.classList.remove('is-visible');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('oc-nav-locked');
    setTimeout(function () { overlay.hidden = true; }, 260);
  }
  /* Lupe nach rechts vor das Konto-Icon verschieben (Alina 07.10.2026) */
  var searchWrap = root.querySelector('[data-oc-nav-search-wrap]');
  var rightCol = root.querySelector('.nav_riight-content');
  if (searchWrap && rightCol) rightCol.insertBefore(searchWrap, rightCol.firstChild);
  burger.addEventListener('click', openDrawer);
  overlay.addEventListener('click', closeDrawer);
  Array.prototype.forEach.call(drawer.querySelectorAll('[data-oc-nav-close]'), function (b) { b.addEventListener('click', closeDrawer); });
  Array.prototype.forEach.call(drawer.querySelectorAll('[data-oc-nav-go]'), function (b) {
    b.addEventListener('click', function () { showLevel(b.getAttribute('data-oc-nav-go')); });
  });
  Array.prototype.forEach.call(drawer.querySelectorAll('[data-oc-nav-back]'), function (b) {
    b.addEventListener('click', function () { showLevel(b.getAttribute('data-oc-nav-back') || 'root'); }); // Ebene 3 → zurück zu Ebene 2, Ebene 2 → root
  });
  var search = drawer.querySelector('[data-oc-nav-search]');
  if (search) search.addEventListener('click', function () { closeDrawer(); });
  Array.prototype.forEach.call(drawer.querySelectorAll('[data-oc-nav-locale]'), function (sel) {
    sel.addEventListener('change', function () { var f = sel.closest('form'); if (f) f.submit(); }); // Land/Sprache wechseln → Shopify-Lokalisierungsformular absenden
  });
  window.addEventListener('resize', function () { if (window.innerWidth >= 992) closeDrawer(); });
})();
